export const SEARCH_CONSTANTS = {
  QUERY_PARAM: 'marksona',
  SEARCH_BASE_URL: '/otsing',
  PAGE_PARAM: 'leht',
  INPUT_MAX_LENGTH: 150,
  PAGE_LIMIT: 20,
  SUGGESTIONS_LIMIT_PER_TYPE: 3,
  SUGGESTED_LABELS_LIMIT: 5,
} as const;
